import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import Card from "../../../Base/Components/Card/Card";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import Loader from "../../../Base/Components/Loader/Loader";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { toastShow } from "../../../Base/Services/ToastService";

// ------------------- CONSULTAS A LA API---------------------------
import { cambiarEstado, getCharAccount } from "../../../API/Finanzas/RegistroContable/RegistroContableRequest";
import { getEstadosCategory } from "../../../API/Global/Status/StatusRequests";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import CharAccountCRUD from "./CharAccountCRUD";

const CharAccountScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [estados, setEstados] = useState([]);
  const [selected, setSelected] = useState(null)
  const [nodes, setNodes] = useState(null)
  const [globalFilter1, setGlobalFilter1] = useState(null);


  const getInfo = async () => {
    setLoading(true);
    const estadosTempo = await getEstadosCategory("General")
    setEstados(estadosTempo?.filter(i => i?.IdStatus !== 7))
    let result = await getCharAccount();
    setData(result);
    cuentasAgrupadas(result)
    setLoading(false);
  };

  const setCeros = (ceros) => {
    let a = '';
    for (let i = 0; i < ceros; i++) {
      a += '0';
    }
    return a;
  };

  const cuentasAgrupadas = (result) => {
    if (result.length > 0) {
      let cuentas = []
      for (let i = 1; i <= 6; i++) {
        let types = result.filter((e) => e.IdType === i)
        cuentas.push(types)
      }

      let tipos = []
      
      cuentas.forEach(e => {
        if (e.length > 0) {
          if (e[0].IdType === 6) {
            let categorias = []
            e.forEach(n => {
              const subCategorias = getSubCategorias(n.IdCategoria, result);

              if (categorias.findIndex(m => "ca" + n.IdCategoria === m.key) < 0) {
                categorias.push({
                  key: "ca" + n.IdCategoria,
                  data: {
                    IdType: n.IdCategoria,
                    NumberAccount: n.IdCategoria !== 6 ?( n.CodigoType + "" + "" + n.CodigoCategoria + setCeros(5)) :  n.CodigoType + setCeros(6),
                    Account: n.Categoria,
                    Description: n.DescriptionCategoria,

                  },
                  children: subCategorias
                })
              }
            })
            let tipo = {
              key: 't' + e[0].IdType,
              data: {
                IdType: e[0].IdType,
                Account: e[0].Type,
                NumberAccount: e[0].CodigoType + setCeros(6),
                Description: e[0].DescriptionType,
              },
              children: categorias,
              style: {
                backgroudColor: "#ccc"
              }
            }
            tipos.push(tipo)
          } else {
            const subCategorias = getSubCategorias(e[0].IdType, result);
            let tipo = {
              key: 't' + e[0].IdType,
              data: {
                IdType: e[0].IdType,
                Account: e[0].Type,
                NumberAccount: e[0].CodigoType + setCeros(6),
                Description: e[0].DescriptionType,

              },
              children: subCategorias

            }
            tipos.push(tipo)
          }
        }
      })
      setNodes(tipos)

      result.forEach(cuenta => {
        if (cuentas.filter(i => i.IdContenerdorAccount === 0) > 0) {
            cuentas.push({
                Clase: cuenta.Clase,
                IdAccount: cuenta.IdAccount,
                NumberAccount: cuenta.NumberAccount,
                CodigoAccount: cuenta.CodigoAccount,
                Account: cuenta.Account,
                SubCategoria: cuenta.SubCategoria,
                Cuentas: result.filter(i => i.IdAccount === cuenta.IdContenedorAccount).map(i => {
                  return i
                })



            })
        }
      });
    }
  }

  const getSubCategorias = (IdCategoria, result) => {
    let sub = []
    if (IdCategoria >= 6) {
      let subCate = result.filter((e) => IdCategoria === e.IdCategoria)

      subCate.forEach(i => {
        if (sub.findIndex(m => m.IdSubCategoria === i.IdSubCategoria) < 0) {
          sub.push(i)
        }
      })
      let resultado = sub.map(e => {
        const cuentas = cuentasHijos(e.IdSubCategoria, result)
        return {
          key: 'sc' + e.IdSubCategoria,
          data: {
            IdType: e.IdSubCategoria,
            Account: e.SubCategoria,
            // NumberAccount: e.CodigoType + "" + e.CodigoCategoria + "" + e.CodigoSubCategoria + setCeros(3),
            NumberAccount: e.IdCategoria !== 6 ?( e.CodigoType + "" + e.CodigoCategoria + "" + e.CodigoSubCategoria + setCeros(3)  ) :  e.CodigoType + "" + e.CodigoSubCategoria + setCeros(4),
            Description: e.DescriptionSubCategoria
          },
          children: cuentas
        }

      })

      return resultado

    }
    else {
      let subCate = result.filter((e) => IdCategoria === e.IdType)
      subCate.forEach(i => {
        if (sub.findIndex(m => m.IdSubCategoria === i.IdSubCategoria) < 0) {
          sub.push(i)
        }
      })
      let resultado = sub.map(e => {
        const cuentas = cuentasHijos(e.IdSubCategoria, result)
        return {
          key: 'sc' + e.IdSubCategoria,
          data: {
            IdType: e.IdSubCategoria,
            Account: e.SubCategoria,
            NumberAccount: e.CodigoType + "" + e.CodigoSubCategoria + setCeros(3),
            Description: e.DescriptionSubCategoria
          },
          children: cuentas
        }
      })
      return resultado
    }
  }

  const cuentasHijos = (IdSubCategoria, result) => {
    let sub = []
    let subCate = result.filter((e) => IdSubCategoria === e.IdSubCategoria)
    subCate.forEach(i => {
      if (i.IdContenedorAccount === 0) {
        sub.push(i)
      }
    })
    let resultado = sub.map(e => {
      let cuentaH = cuHijos(e.IdAccount, result)
      return {
        key: 'cc' + e.IdAccount,
        data: {
          IdType: e.IdAccount,
          Account: e.Account,
          NumberAccount: e.CodigoAccount,
          Description: e.DescriptionCharAccount
        },
        children: cuentaH
      }

    })
    return resultado
  }

  const cuHijos = (IdAccount, subCate) => {
    let hijos = []
    subCate.forEach(i => {
      if (i.IdContenedorAccount === IdAccount) {
        hijos.push({
            key: 'ah' + i.IdAccount,
            data: {
              IdType: i.IdAccount,
              Account: i.Account,
              NumberAccount: i.CodigoAccount,
              Description: i.DescriptionCharAccount
            },
            children: cuHijos(i.IdAccount, subCate)
        })
      }
    })
    return hijos
  }

  const treeTableFuncMap = {
    'globalFilter1': setGlobalFilter1
  };

  const rowClassName = (node) => {
    switch (true) {
      case node.key.toString().includes('t'):
        return { 'p-highTipos': (true) };
        break;
      case node.key.toString().includes('ca'):
        return { 'p-highCategoria': (true) };
        break;
      case node.key.toString().includes('sc'):
        return { 'p-highSubCategoria': (true) };
        break;
      case node.key.toString().includes('cc'):
        return { 'p-highCuentas': (true) };
        break;
      case node.key.toString().includes('ah'):
        return { 'p-highCuentasHijos': (true) };
        break;
      default:
        return { 'p-highFill': (true) }
        break;
    }
  }

  const getHeader = (globalFilterKey) => {
    return (
      <div className="d-flex flex-row text-right">
        <div className="p-input-icon-right">
          <span className="p-float-label">
            <InputText
              type="search"
              onInput={(e) =>treeTableFuncMap[`${globalFilterKey}`](e.target.value)}
              size="50"
            />
            <label>Buscar Cuenta</label>
          </span>
        </div>
        <div>
          <Button
            icon="pi pi-refresh"
            onClick={() => getInfo()}
            className="mx-2"
            loading={loading}
          />
        </div>
      </div>
    );
  }

  let header1 = getHeader('globalFilter1');

  const changeEstado = ({ data, api }) => {
    return <div>
          <Dropdown
            value={estados.filter(e => e.IdStatus === data.IdStatus)}
            options={estados}
            optionLabel="StatusName"
            filter
            filterBy="StatusName"
            style={{ width: '100%' }}
            onChange={(e) => {
              if(e.value.IdStatus !== data?.IdStatus){
                let changes = []
                changes.push({ IdAccount: data.IdAccount, IdStatus: e.value.IdStatus, StatusName: e.value.StatusName })
                confirmDialog({
                    message: `¿Cambiar a estado a: ${data.CodigoAccount} - ${data?.Account} ?`,
                    header: 'Confirmación',
                    icon: 'pi pi-exclamation-triangle',
                    accept: async () => {
                      if(e.value.IdStatus !== data?.IdStatus){
                        cambiarEstadoCliente(e.value.IdStatus, data.IdAccount);
                        getInfo()
                      }
                      api.stopEditing();
                    },
                    reject: () => {}
                })
              }else{
                api.stopEditing();
              }
            }}
          />
        </div>
  }

  const cambiarEstadoCliente = async (IdStatus, IdAccount) => {
    const result = await cambiarEstado({IdStatus, IdAccount});
    toastShow(toast, "success", 'Editado', "Estado cambiado correctamente");
  }

  const colums = [
    {
      header: 'ID',
      headerEn: 'ID',
      field: 'IdAccount',
      className: 'XXsmall',
      frozen: true,
      hidden: userAuth?.IdRol === 1
    },
    {
      field: "DateCreateStr",
      header: "Fecha Creación",
      headerEn: "Date Create",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        setShowDialog(true)
      },
      Format: "DateTime",
    },
    {
      field: "StatusName",
      header: "Estado",
      Sumary: 'count',
      headerEn: "Status",
      className: "Xsmall",
      cellEditor: changeEstado,
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Format: "Estado",
      editable: true,
    },
    {
      header: 'Número',
      headerEn: 'Number',
      field: 'CodigoAccount',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        setShowDialog(true)
      },
      className: 'Xsmall',
    },
    {
      header: 'Cuenta',
      headerEn: 'Account',
      field: 'Account',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        setShowDialog(true)
      },
      className: 'Xlarge',
    },
    {
      header: 'Moneda',
      headerEn: 'Currency',
      field: 'Divisa',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        setShowDialog(true)
      },
      className: 'Xsmall',
    },
    {
      header: 'Descripción',
      headerEn: 'Description',
      field: 'Description',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        setShowDialog(true)
      },
      className: 'medium',
      flex: 1,
      minWidth:200,
    },
    {
        header: 'Contenedor',
        headerEn: 'Container',
        field: 'CuentaConcatenadaCont',
        onCellDoubleClicked: ({ data }) => {
          setSelected(data)
          setShowDialog(true)
        },
        className: 'Xlarge',
      },
    {
        header: 'Saldo',
        headerEn: 'Saldo',
        field: 'Saldo',
        onCellDoubleClicked: ({ data }) => {
          setSelected(data)
          setShowDialog(true)
        },
        className: 'Xsmall',
        Format: "Currency",
    },
    {
        header: 'Tipo',
        headerEn: 'Type',
        field: 'Type',
        onCellDoubleClicked: ({ data }) => {
          setSelected(data)
          setShowDialog(true)
        },
        className: 'small',
    },
    {
        header: 'Categoría',
        headerEn: 'Category',
        field: 'Categoria',
        onCellDoubleClicked: ({ data }) => {
          setSelected(data)
          setShowDialog(true)
        },
        className: 'small',
    },
    {
        header: 'Sub Categoría',
        headerEn: 'Sub Category',
        field: 'SubCategoria',
        onCellDoubleClicked: ({ data }) => {
          setSelected(data)
          setShowDialog(true)
        },
        className: 'small',
    },
    {
      header: 'Cuenta Hermana',
      field: 'Cuenta',
      onCellDoubleClicked: ({ data }) => {
        setSelected(data)
        setShowDialog(true)
      },
      className: 'large',
    },
    {
      header: 'Usuario Creación',
      headerEn: 'User Create',
      field: 'UserNameCreate',
      className: 'medium',
    },
    {
      header: 'Usuario Edición',
      headerEn: 'User Edit',
      field: 'UserNameEdit',
      className: 'medium',
    },
    {
      field: "DateEditStr",
      header: "Fecha Edición",
      headerEn: "Edit Date",
      className: "medium",
      Format: "DateTime",
    },
    {
      field: "IdAccount",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdAccount){
              setSelected(rowData)
              setShowDialog(true)
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ]

  const table = {
    Columns: colums,
    Data: data,
    showModal: () => {}
  }

  useEffect(() => {
    getInfo();
    setTitlePage(getLabel(baseLang, "TipoCuenta", config.language));
  }, []);
  
  return (
    <div>
      <Toast ref={toast} />
      <Card
        contenido={
          <div className="pt-1">
            <Loader loading={loading} />
            <TabView
              className="col-12 homeTabView"
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Listado de Cuentas">
                <div className="pt-2" style={{ height: "80vh" }} Id="PlanCuentasTable">
                  <TreeTable value={nodes} rowClassName={rowClassName} globalFilter={globalFilter1} header={header1} scrollable scrollHeight="60vh">
                    <Column field="NumberAccount" header="Nombre" expander></Column>
                    <Column field="Account" header="Cuenta"></Column>
                    <Column field="Description" header="Descripción"  ></Column>
                  </TreeTable>
                </div>
              </TabPanel>
              <TabPanel header="Plan de cuentas">
                <div className="d-flex mx-2 mt-2 gap-2">
                  <Button
                    icon="pi pi-plus"
                    tooltip="Nuevo"
                    onClick={(e) => {
                      setShowDialog(true);
                      setSelected(null);
                    }}
                  />

                  <Button
                    icon="pi pi-refresh"
                    tooltip="Buscar"
                    onClick={() => getInfo()}
                  />
                </div>
                <div className="mx-2 mt-2" style={{ height: "80vh" }}>
                  <AgGrid table={table} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        }
      />

      {showDialog && (
        <CharAccountCRUD
          showDialog={showDialog}
          selected={selected}
          setSelected={setSelected}
          setShowDialog={setShowDialog}
          getInfo={getInfo}
        />
      )}
    </div>
  );
};

export default CharAccountScreen;
